import React from 'react';
import {useLocation} from 'react-router-dom';
import {useAuth} from '../auth-context';

const PricingTable = () => {
    const location = useLocation();
    const { user: authUser } = useAuth();
    const user = location.state?.user || authUser;
    const email = user?.email;
    const clientReferenceId = user?._id || user?.id || user?.userId;

    return (
        <stripe-pricing-table
            pricing-table-id="prctbl_1RpNbOPF0zYf4eCuA5HQwC7w"
            publishable-key="pk_test_51RpMq7PF0zYf4eCu7YAyIuMxMFtCr0AWBqFnneAape9SXIGUUKkNhoW0OlnHQlT8hz5YDL1g0AWxrEJp803MKBhd00xiHbGOra"
            customer-email={email}
            client-reference-id={clientReferenceId}
        >
        </stripe-pricing-table>
    );
};

export default PricingTable;
